export default __webpack_public_path__ + "static/media/product8.46f95ab2.webp";